const MODAL = {

    //Defined types of modal's content
    VIDEO: 1,
    IMAGE: 2,
    DIALOG:3
}

export default MODAL


// WEBPACK FOOTER //
// ./src/constants/modal-types.js